import { render, staticRenderFns } from "./OfferTemplate.vue?vue&type=template&id=487a9ed4&scoped=true"
import script from "./OfferTemplate.vue?vue&type=script&lang=js"
export * from "./OfferTemplate.vue?vue&type=script&lang=js"
import style0 from "./OfferTemplate.vue?vue&type=style&index=0&id=487a9ed4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487a9ed4",
  null
  
)

export default component.exports